module.exports = __webpack_public_path__ + "static/media/wolf3.92bcd063.png";